/*
Sohel       09/21/2022  2698823069   Fixed Client Maintainance Bugs
Saikrishna  10/06/2022  2698823069   Removed unecesarry console.log statements
Dilip 11/02/2022 2698823069 Added back to dashboard button
Sohel 05/26/2023 2698823069 Added Created Date Validation
Akhila 06/08/2023 2698823069 created date change to date created field and column
*/
import React, {useState, useEffect, useContext} from 'react';
import {
  TextField,
  FormControl,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from '@material-ui/core';
import DialogBox from '../../../../components/DialogBox';
import EditSubServiceTypeDialog from './EditSubServiceTypeDialog';
import {useHistory, useLocation} from 'react-router';
import {useSelector, useDispatch} from 'react-redux';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {ArrowBack} from '@material-ui/icons';
import ClientAccordion from './ClientAccordion';
import SubServiceTypeTable from './SubServiceTypeTable';
import {
  fetchClientGeneral,
  resetMessage,
  fetchClientParent,
  fetchDropDowns,
  fetchClientService,
  updateClientGeneral,
  resetUpdateStatus,
} from '../../../../redux/reducers/client-maintainance/ClientGeneral';
import {CLIENT_CLASS, LOCATION_CODE, STATE} from '../../../../constants/Lookup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import moment from 'moment';
import formatPhoneNumber from '../../../../util/PhoneFormat';
import * as Yup from 'yup';
import {getObject} from '../../../../util/GetDropdownObject';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {Form, Formik} from 'formik';
import {makeStyles} from '@material-ui/core';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';

const useStyles = makeStyles((theme) => ({
  cardStyling: {
    'whiteSpace': 'nowrap',
    'padding': '10px',
    'borderRadius': 8,
    'backgroundColor': '#ededed',
    'marginBottom': 10,
    'boxShadow':
      '0px 1px 0px rgb(0 0 0 / 10%), 0px 0px 1px rgb(0 0 0 / 10%), 0px 1px 2px rgb(0 0 0 / 10%)',
    '& .MuiTypography-h3': {
      padding: '3px 0 12px 0;',
    },
    '& .MuiCircularProgress-colorPrimary': {
      position: 'fixed',
      top: '365px',
    },
  },
}));
const initialVal = {
  createdDate: '',
  clientName: '',
  clientNumber: '',
  phoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  zipCode: '',
  contactName: '',
  clientCode: '',
  locationCode: '',
  classOfClient: '',
  state: '',
  isActive: false,
  serviceType: '',
  subServiceType: [],
  companyType: '',
  parentClient: '',
};


const firstLetterCap = (val) => val && val[0]?.toUpperCase() + val?.slice(1);
const General1 = () => {
  const dispatch = useDispatch();
  const {
    clientGeneralData,
    dropDownData,
    updatedClientCodeStatus,
    postRateCardStatus,
    errorMsg,
    successMsg,
    isLoading,
  } = useSelector(({clientGeneral}) => clientGeneral);
  const {deleteRateStatus} = useSelector(({clientRateHistory}) => clientRateHistory);
  const location = useLocation();
  const clientNumber = location?.state?.clientNumber;
  const [subscribedServiceData, setSubscribedServiceData] = useState([]);
  const [editSubServiceDialog, setEditSubServiceDialog] = useState(false);
  const [rowData, setRowData] = useState({});
  const [historyData, setHistoryData] = useState([]);
  const [initialValues, setInitialValues] = useState(initialVal);
  const {roleData} = useSelector(({role}) => role);
  const disabledByRole = roleData?.window?.['Client Maintenance']?.AC;
  const disableCG = roleData?.window?.['Client Maintenance']?.CG?.edit;
  useEffect(() => {
    if (clientNumber) {
      dispatch(fetchClientGeneral(clientNumber));
    }
  }, []);

  const validationSchema = Yup.object().shape({
    clientName: Yup.string().max(40, 'Client Name cannot exceed 40 characters'),
    addressLine1: Yup.string().max(50, 'Address Line 1 cannot exceed 50 characters'),
    addressLine2: Yup.string().max(50, 'Address Line 2 cannot exceed 50 characters'),
    zipCode: Yup.string()
      .min(5, 'Zip cannot be less than 5 characters')
      .max(9, 'Zip cannot exceed 9 characters'),
    city: Yup.string().max(20, 'City cannot exceed 20 characters'),
    createdDate: Yup.date().typeError('Invalid date format'),
  });

  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const classes1 = useStyles();
  const history = useHistory();

  const onSubmit = (data) => {
    if (data && clientNumber) {
      dispatch(
        updateClientGeneral({
          clientName: data?.clientName,
          city: data?.city,
          zipCode: data?.zipCode,
          addressLine1: data?.addressLine1,
          addressLine2: data?.addressLine2,
          phoneNumber: data?.phoneNumber ? Number(data?.phoneNumber?.replace(/[^\d]/g, '')) : '',
          classOfClient: data?.classOfClient?.valueCode ? data.classOfClient.valueCode : '',
          locationCode: data?.locationCode?.valueCode ? data.locationCode.valueCode : '',
          contactName: data?.contactName,
          isActive: 'Y',
          clientNumber: clientNumber,
          state: data?.state?.valueCode ? data.state.valueCode : '',
          classOfClient2: data?.serviceType,
        }),
      );
    }
  };
  useEffect(() => {
    if (updatedClientCodeStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
      dispatch(resetUpdateStatus());
      dispatch(fetchClientGeneral(clientNumber));
    } else {
      dispatch(fetchClientGeneral(clientNumber));
    }
  }, [updatedClientCodeStatus]);

  useEffect(() => {
    if (postRateCardStatus && postRateCardStatus.status === 200) {
      setTimeout(() => {
        dispatch(fetchClientGeneral(clientNumber));
        dispatch(resetMessage());
      }, 2000);
    }
    if (deleteRateStatus === 200) {
      dispatch(fetchClientGeneral(clientNumber));
    }
  }, [postRateCardStatus, deleteRateStatus]);

  useEffect(() => {
    dispatch(fetchDropDowns());
    dispatch(fetchClientService());
    dispatch(fetchClientParent());
  }, []);

  useEffect(() => {
    if (Object.keys(clientGeneralData)) {
      const initialVal = {
        createdDate: clientGeneralData?.createdDate ?
          moment(clientGeneralData.createdDate, 'DD-MM-YYYY').format('MM/DD/YYYY') :
          null,
        clientName: clientGeneralData?.clientName ? clientGeneralData.clientName : '',
        clientNumber: clientGeneralData?.clientNumber ? clientGeneralData.clientNumber : '',
        phoneNumber: clientGeneralData?.phoneNumber ?
          formatPhoneNumber(clientGeneralData.phoneNumber) :
          '',
        addressLine1: clientGeneralData?.addressLine1 ? clientGeneralData.addressLine1 : '',
        addressLine2: clientGeneralData?.addressLine2 ? clientGeneralData.addressLine2 : '',
        city: clientGeneralData?.city ? clientGeneralData.city : '',
        zipCode: clientGeneralData?.zipCode ? clientGeneralData.zipCode : '',
        contactName: clientGeneralData?.contactName ? clientGeneralData.contactName : '',
        clientCode: clientGeneralData?.clientCode ? clientGeneralData.clientCode : '',
        locationCode: clientGeneralData?.locationCode ?
          getObject(clientGeneralData.locationCode, LOCATION_CODE, dropDownData) :
          '',
        classOfClient: clientGeneralData?.classOfClient ?
          getObject(clientGeneralData.classOfClient, CLIENT_CLASS, dropDownData) :
          '',
        state: clientGeneralData?.state ?
          getObject(clientGeneralData.state, 'STATE', dropDownData) :
          '',
        isActive: clientGeneralData.isActive === 'Y',
        serviceType: clientGeneralData?.serviceType ? clientGeneralData.serviceType : '',
        subServiceType: clientGeneralData?.subServiceType ? clientGeneralData.subServiceType : '',
        companyType: clientGeneralData?.companyType ? clientGeneralData.companyType : '',
        parentClient: clientGeneralData?.parentClientName ? clientGeneralData.parentClientName : '',
      };
      setInitialValues(initialVal);
    }
  }, [clientGeneralData, dropDownData]);

  const handleSubServiceDialog = () => {
    setEditSubServiceDialog(false);
  };

  return (
    <>
      <div className={classes1.cardStyling}>
        <Formik
          onSubmit={(values) => onSubmit(values)}
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              setFieldValue,
              handleReset,
              touched,
              errors,
            } = props;
            return (
              <Form>
                <div className="d-flex align-items-center mb-3">
                  <Button
                    className={`search-btn`}
                    variant="outlined"
                    onClick={() => {
                      history.push('/client-search');
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    BACK TO DASHBOARD
                  </Button>
                </div>
                <div className={classes.cardStyles}>
                  <div>
                    <Typography className="mb-2 module-heading" variant="h1">
                      Client General
                    </Typography>
                  </div>
                  <div className="block-styling">
                    <div className="form-row">
                      <div className="col-lg-3 col-md-3 col-sm-6  form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Client Code"
                          margin="dense"
                          name="clientNumber"
                          value={values.clientNumber}
                          variant="outlined"
                          label="Client Code"
                          disabled
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                      </div>
                      <div className="col-md-3  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Client Name"
                          margin="dense"
                          name="clientName"
                          disabled
                          variant="outlined"
                          label="Client Name"
                          value={values.clientName}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                        <FormHelperText variant="outlined">
                          {errors.clientName?.message ? errors.clientName.message : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-3  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Parent Client"
                          disabled
                          margin="dense"
                          value={values.parentClient}
                          name="parentClient"
                          variant="outlined"
                          label="Parent Client"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-4 col-md-3 col-lg-3 form-group">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <Grid container>
                            <KeyboardDatePicker
                              aria-hidden="true"
                              className={`${classes.datePicker} ${classes.labelName}`}
                              format="MM/dd/yyyy"
                              placeholder="MM/DD/YYYY"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              disabled
                              inputVariant="outlined"
                              name="createdDate"
                              label="Date Created"
                              autoOk
                              margin="dense"
                              error={Boolean(touched?.createdDate && errors?.createdDate)}
                            />
                          </Grid>
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      {/* commented for future use */}
                      {/* <div className=" col-lg-1 col-md-2  col-sm-2">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.isActive}
                              onChange={handleChange}
                              name="isActive"
                              color="primary"
                            />
                          }
                          label="Active"
                        />
                      </div> */}
                      <div className="col-lg-4 col-md-4  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Company Type"
                          margin="dense"
                          name="companyType"
                          value={values.companyType}
                          variant="outlined"
                          disabled
                          label="Company Type"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                      </div>
                      <div className="col-lg-5  col-md-6  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Service Type"
                          margin="dense"
                          name="serviceType"
                          disabled
                          variant="outlined"
                          value={values.serviceType}
                          label="Service Type"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                      <SubServiceTypeTable
                        subscribedServiceData={subscribedServiceData}
                        setSubscribedServiceData={setSubscribedServiceData}
                        setEditSubServiceDialog={setEditSubServiceDialog}
                        setRowData={setRowData}
                        historyData={historyData}
                        firstLetterCap={firstLetterCap}
                      />
                    </div>
                    {/* commented for future use */}
                    {/* <div className="mb-3">
                      <UnSubscribedServiceTable
                        clientGeneralData={clientGeneralData}
                        editSubServiceDialog={editSubServiceDialog}
                        setEditSubServiceDialog={setEditSubServiceDialog}
                        setRowData={setRowData}
                        firstLetterCap={firstLetterCap}
                      />
                    </div> */}
                  </div>
                  <div className="block-styling">
                    <div className="form-row">
                      <div className="col-xl-3 col-md-4  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Address Line 1"
                          margin="dense"
                          name="addressLine1"
                          variant="outlined"
                          value={values.addressLine1}
                          onChange={handleChange}
                          label="Address Line 1"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          error={errors && errors?.addressLine1}
                        />
                        <FormHelperText variant="outlined">
                          {errors?.addressLine1 ? errors.addressLine1 : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xl-3 col-md-4  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Address Line 2"
                          margin="dense"
                          name="addressLine2"
                          variant="outlined"
                          value={values.addressLine2}
                          onChange={handleChange}
                          label="Address Line 2"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          error={errors && errors.addressLine2}
                        />
                        <FormHelperText variant="outlined">
                          {errors?.addressLine2 ? errors.addressLine2 : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xl-2 col-md-4  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter City"
                          margin="dense"
                          name="city"
                          variant="outlined"
                          label="City"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={values.city}
                          onChange={handleChange}
                          fullWidth
                          error={errors && errors.city}
                        />
                        <FormHelperText variant="outlined">
                          {errors?.city ? errors.city : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xl-2 col-md-4  col-sm-6 form-group">
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            id="state"
                            options={getOptions(STATE, dropDownData)}
                            size="small"
                            value={values.state}
                            autoHighlight
                            getOptionLabel={(option) => {
                              return option && option.valueCode && option.value ?
                                option.valueCode + ' - ' + option.value :
                                option.value === null ?
                                  option.valueCode :
                                  '';
                            }}
                            renderInput={(params) => (
                              <GuiTextField
                                className={`${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="State"
                                name="state"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                placeholder="Select State"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off', // disable autocomplete and autofill
                                }}
                              />
                            )}
                            onChange={(_, data) => {
                              setFieldValue('state', data);
                            }}
                          />
                        </FormControl>
                      </div>
                      <div className="col-xl-2 col-md-4  col-sm-6 form-group">
                        <TextField
                          className={` ${classes.labelName} ${classes.inputLabel}`}
                          placeholder="Enter Zip"
                          margin="dense"
                          name="zipCode"
                          variant="outlined"
                          label="Zip"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={values.zipCode}
                          onChange={handleChange}
                          fullWidth
                        />
                        <FormHelperText variant="outlined">
                          {errors.zipCode ? errors.zipCode : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-xl-3 col-md-4  col-sm-6 form-group">
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            id="locationCode"
                            options={getOptions(LOCATION_CODE, dropDownData)}
                            size="small"
                            autoHighlight
                            getOptionLabel={(option) => {
                              return option && option.valueCode && option.value ?
                                option.valueCode + ' - ' + option.value :
                                option.value === null ?
                                  option.valueCode :
                                  '';
                            }}
                            value={values.locationCode}
                            renderInput={(params) => (
                              <GuiTextField
                                className={`${classes.labelName} ${classes.selectLabel}`}
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Location Code"
                                name="locationCode"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                placeholder="Select Location Code"
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off', // disable autocomplete and autofill
                                }}
                              />
                            )}
                            onChange={(_, data) => {
                              setFieldValue('locationCode', data);
                            }}
                          />
                        </FormControl>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center mt-3">
                    <Button
                      type="button"
                      onClick={() => handleReset()}
                      variant="contained"
                      className={`mx-1 ${classes.buttonRoot}`}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      className={`themeing-buttons mx-1 ${classes.buttonRoot}`}
                      color="primary"
                      disabled={
                        !disabledByRole?.add || (clientGeneralData?.clientName && !disableCG)
                      }
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
        {isLoading && <PageLoader />}
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
        <DialogBox
          open={editSubServiceDialog}
          title="Edit"
          maxWidth={'md'}
          dialogClose={handleSubServiceDialog}
        >
          <EditSubServiceTypeDialog
            rowData={rowData}
            historyData={historyData}
            clientNumber={clientNumber}
            handleSubServiceDialog={handleSubServiceDialog}
            setHistoryData={setHistoryData}
            setEditSubServiceDialog={setEditSubServiceDialog}
            companyType={initialValues.companyType}
          />
        </DialogBox>
      </div>
      <ClientAccordion />
    </>
  );
};

export default General1;
